/**
 * Subscription resource - /api/subscription endpoints
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.SubscriptionResource');
export class SubscriptionResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * Get subscription information including limits
     */
    async getInfo() {
        log.debug('Getting subscription info');
        try {
            const info = await this.http.get('/api/subscription/info');
            log.debug('Subscription info retrieved', {
                plan: info.plan,
                currentProjects: info.currentProjects,
                projectLimit: info.projectLimit,
                currentDevices: info.currentDevices,
                deviceLimit: info.deviceLimit
            });
            return info;
        }
        catch (error) {
            log.error('Failed to get subscription info', {
                error: error instanceof Error ? error.message : String(error),
            });
            // Return default free plan info on error
            return {
                plan: 'free',
                status: 'active',
                currentProjects: 0,
                projectLimit: 1,
                canCreateMore: false,
                currentDevices: 0,
                deviceLimit: 2,
                canCreateMoreDevices: false,
                subscription: null,
            };
        }
    }
}
//# sourceMappingURL=SubscriptionResource.js.map